import { IconType } from "react-icons";
import { Link } from "react-router-dom";

type LinkButtonProps = {
  to: string;
  text: string;
  icon?: IconType;
};

export const LinkButton: React.FC<LinkButtonProps> = ({ to, text, icon: Icon }) => {
  return (
    <Link
      to={to}
      className={
        "bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md shadow-md flex items-center space-x-2 no-underline "
      }
    >
      {Icon && <Icon />}
      <span>{text}</span>
    </Link>
  );
};
